import { useState } from 'react';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { useRachelChat } from '../../../../services/modules/rachelChats/rachelChats.queries';
import { useRachelChatContext } from '../../contexts/Rachel.context';
import { useRachelActiveChatId } from '../../hooks/useRachelActiveChatId';
import { useRachelPageNavigation } from '../../hooks/useRachelPageNavigation';
import { useRachelPresentation } from '../../hooks/useRachelPresentation';
import { useRachelStore } from '../../store/rachel.store';
import { selectCloseRachel, selectOpenRachel } from '../../store/rachel.store.selectors';

export const useRachelHeader = () => {
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const activeChatId = useRachelActiveChatId();
  const open = useRachelStore(selectOpenRachel);
  const close = useRachelStore(selectCloseRachel);
  const presentation = useRachelPresentation();
  const { openPage, leavePage, canGoBack } = useRachelPageNavigation();
  const { isEnableRachelChat } = useFeatureFlag();
  const activeChatQuery = useRachelChat(activeChatId);
  const { messages } = useRachelChatContext();

  const openHistory = () => setIsHistoryOpen(true);
  const closeHistory = () => setIsHistoryOpen(false);

  const toggleMaximize = () => {
    if (presentation.mode === 'page') {
      open();
      leavePage();
      return;
    }

    openPage();
  };

  const isCollapseDisabled = presentation.mode === 'page' && isEnableRachelChat && !canGoBack;

  return {
    isHistoryOpen,
    presentation,
    openHistory,
    closeHistory,
    toggleMaximize,
    isCollapseDisabled,
    close,
    hasConversation: !!activeChatId || messages.length > 0,
    activeChatTitle: activeChatQuery.data?.title ?? null,
    isLoadingActiveChatTitle: activeChatQuery.isLoading,
  };
};
